import { CLASSIFICATION_ALL, SALUTATIONS } from "../api/diagnosticDoctorApi";

/** Backend may return "Dr." while dropdown options use "Dr". */
export const normalizeSalutation = (value = "") => {
  const trimmed = String(value || "").trim().replace(/\.$/, "");
  if (!trimmed) return "";
  const match = SALUTATIONS.find(
    (item) => item.toLowerCase() === trimmed.toLowerCase(),
  );
  return match || trimmed;
};

export const salutationSelectOptions = (currentValue = "") => {
  const normalized = normalizeSalutation(currentValue);
  if (normalized && !SALUTATIONS.includes(normalized)) {
    return [...SALUTATIONS, normalized];
  }
  return SALUTATIONS;
};

/** Capitalized strings sent as add_new_user/ / edit_user/ user_type. */
export const DIAGNOSTIC_USER_TYPES = ["Radiologist", "Pathologist"];

export const isDiagnosticUserType = (userType) => {
  const value = String(userType || "").trim().toLowerCase();
  return value === "radiologist" || value === "pathologist";
};

export const normalizeDiagnosticUserType = (userType) => {
  const value = String(userType || "").trim().toLowerCase();
  if (value === "radiologist") return "Radiologist";
  if (value === "pathologist") return "Pathologist";
  return String(userType || "").trim();
};

const toIsoDate = (value) => {
  if (!value) return undefined;
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return value.toISOString().split("T")[0];
  }
  const text = String(value).trim();
  return text || undefined;
};

export const resolveDiagnosticAddress = (data = {}) => {
  const explicit = String(data.address || "").trim();
  if (explicit) return explicit;

  return [data.city, data.district, data.state]
    .map((part) => String(part || "").trim())
    .filter(Boolean)
    .join(", ");
};

const parseClassificationId = (value) => {
  if (
    value === CLASSIFICATION_ALL ||
    value === "" ||
    value == null ||
    value === "__all__"
  ) {
    return null;
  }
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
};

export const buildAddNewUserDiagnosticPayload = (data, doctorSignature) => {
  const payload = {
    user_type: normalizeDiagnosticUserType(data.user_type),
    username: (data.username || "").trim(),
    password: data.password || "",
    email: (data.email || "").trim(),
    first_name: (data.first_name || "").trim(),
    last_name: (data.last_name || "").trim(),
    service_group_id: Number(data.service_group_id),
    service_classification_id: parseClassificationId(
      data.service_classification_id,
    ),
    registration_no: data.registration_no || "",
    salutation: data.salutation || "",
    specialization: data.specialization || "",
    qualifications: data.qualifications || "",
    gender: data.gender || "",
    phone_no: data.phone_no || "",
    city: data.city || "",
    state: data.state || "",
    district: data.district || "",
    address: resolveDiagnosticAddress(data),
    active: data.active === "on" || data.active === true,
    doctor_signature: doctorSignature || null,
  };

  const dob = toIsoDate(data.dob);
  const dateJoined = toIsoDate(data.date_joined);
  if (dob) payload.dob = dob;
  if (dateJoined) payload.date_joined = dateJoined;

  return payload;
};

export const buildEditUserDiagnosticPayload = (data, doctorSignature) => {
  const payload = {
    username: (data.username || "").trim(),
    user_type: normalizeDiagnosticUserType(data.user_type),
    first_name: (data.first_name || "").trim(),
    last_name: (data.last_name || "").trim(),
    email: (data.email || "").trim(),
    service_group_id: Number(data.service_group_id),
    service_classification_id: parseClassificationId(
      data.service_classification_id,
    ),
    specialization: data.specialization || "",
    registration_no: data.registration_no || "",
    salutation: data.salutation || "",
    qualifications: data.qualifications || "",
    gender: data.gender || "",
    phone_no: data.phone_no || "",
    active: data.active === true || data.active === "true",
  };

  if (data.password) {
    payload.password = data.password;
  }
  if (doctorSignature) {
    payload.doctor_signature = doctorSignature;
  }

  const dob = toIsoDate(data.dob);
  const dateJoined = toIsoDate(data.date_joined);
  if (dob) payload.dob = dob;
  if (dateJoined) payload.date_joined = dateJoined;

  return payload;
};
